var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("br"),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("H1", { staticClass: "pageTitle isPoppins" }, [
          _vm._v("Privacy Policy")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "accSettingsForm top20" }, [
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [
                _vm._v("This\nPrivacy Policy governs the "),
                _c("span", { staticClass: "GramE" }, [
                  _vm._v("manner in which")
                ]),
                _vm._v(
                  " Slink, Inc.\ncollects, uses, maintains and discloses information collected from its users\n(each, a “User”) through the www.slink.com website (“Site”). This Privacy\nPolicy applies to the Site and all services arising therefrom provided by Slink,\nInc."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [
                _vm._v("Last\nModified: May 4"),
                _c("sup", [_vm._v("th")]),
                _vm._v(", 2021"),
                _c("br"),
                _vm._v(" "),
                _c("p", { staticClass: "MsoNormal" }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-family": '"Arial",sans-serif',
                        "mso-hansi-theme-font": "minor-latin",
                        "mso-bidi-theme-font": "minor-latin"
                      }
                    },
                    [_vm._v(" ")]
                  )
                ]),
                _vm._v(" "),
                _c("b", [_vm._v("Personal Identification Information")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\nWe may collect personal identification information from prospective and/or\nactive Users in a variety of ways, including, but not limited to, when visiting\nour Site, registering on the Site to become a User, subscribing to certain\nservices, and/or in connection with other activities, "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("features")]),
                _vm._v(
                  "\nor resources we make available from time-to-time on our Site. To register to\nbecome a User, the viewer may be asked for, as appropriate, name, email\naddress, mailing address, phone number, and/or credit card information. Viewers\nmay also, however, visit our Site anonymously. We will collect personal\nidentification information from prospective Users only if they voluntarily\nsubmit such information to us. Prospective Users can always refuse to supply\ncertain personal identification information, except that it may prevent them\nfrom engaging in certain Site related activities."
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Non-personal Identification Information")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\nWe may collect non-personal identification information whenever a Viewer\ninteracts with our Site. Non-personal identification information may include,\nbut may not be limited to, the Viewer’s browser name, the type of computer, and\ntechnical information about the means of connection to our Site, such as the\noperating system and the Internet service providers utilized and other similar\ninformation."
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Web Browser Cookies")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\nOur Site uses “cookies” to enhance the Viewer experience. Web browsers place\ncookies on a Viewer’s hard drive for record-keeping purposes and sometimes to\ntrack information about them. We use cookies to track items within shopping\ncarts and to maintain session information on logged in users so that they do\nnot have to log in every time they visit the Site."
                ),
                _c("span", { staticStyle: { "mso-spacerun": "yes" } }),
                _vm._v(
                  "Viewers may choose to set their web browser\nto refuse cookies, or set alerts when cookies are being sent. If a Viewer takes\nthese actions, some sections of our Site may not function properly for the\nViewer."
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("How We Use Collected Information")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\nSlink, Inc may collect and use personal information described above for the\nfollowing purposes:"
                ),
                _c("br"),
                _vm._v("\n- To improve customer service"),
                _c("br"),
                _vm._v(
                  "\n- To help us respond to customer service requests and support needs more\nefficiently"
                ),
                _c("br"),
                _vm._v("\n- To personalize the Viewer experience"),
                _c("br"),
                _vm._v(
                  "\n- To understand how our Viewers, as a group, use our services and resources\nprovided on our Site"
                ),
                _c("br"),
                _vm._v("\n- To improve our Site"),
                _c("br"),
                _vm._v(
                  "\n- To receive feedback to improve our products and services"
                ),
                _c("br"),
                _vm._v("\n- To process payments"),
                _c("br"),
                _vm._v(
                  "\n- To provide service and support for a User’s order. We do not share this\ninformation with outside parties except to the extent necessary to provide the\nservice"
                ),
                _c("br"),
                _vm._v("\n- To send periodic emails"),
                _c("br"),
                _vm._v(
                  "\n- To send Users certain information and updates pertaining to any order. We may\nalso use it to respond to inquiries, questions, and/or other requests"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [
                _c("br"),
                _vm._v(
                  "\nBy opting-in to our mailing lists, a User agrees to receive emails that may\ninclude company news, updates, related "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("product")]),
                _vm._v(
                  " or\nservice information, etc. If at any time that person would like to unsubscribe\nfrom receiving future emails, we include detailed unsubscribe instructions at\nthe bottom of each email."
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("How We Protect Your Information")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\nWe adopt appropriate data collection, storage and processing practices and\nsecurity measures to protect against unauthorized access, alteration,\ndisclosure or destruction of your personal information, username, password,\ntransactional "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("information")]),
                _vm._v(
                  " and data stored on our Site.\nSensitive and private data exchanged between our Site and its Users occurs over\nan SSL secured communication channel and is encrypted and protected with\ndigital signatures. Slink, Inc., does not store credit card information, rather\nthis process is outsourced to a third-party payment provider, Stripe.com."
                ),
                _c("span", { staticStyle: { "mso-spacerun": "yes" } }),
                _vm._v(
                  "For information about how they handle this\ninformation please visit their website."
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Sharing Your Personal Information")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\nWe do not sell, trade, or rent personal identification information to others.\nWe may share generic aggregated demographic information not linked to any\npersonal identification information regarding visitors and users with our\nbusiness partners, trusted affiliates and advertisers for the purposes outlined\nabove."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [_c("b", [_vm._v("Deleting Your Account")])]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [
                _vm._v(
                  "If\nyou would like to delete your account and all data related to it, please send a\nrequest using the DELETE ACCOUNT button within the Account Settings page of the site."
                ),
                _c("span", { staticStyle: { "mso-spacerun": "yes" } }),
                _c("span", { staticStyle: { "mso-spacerun": "yes" } }),
                _vm._v(
                  "In no event will we issue refunds\nto services you have paid for "
                ),
                _c("span", { staticClass: "GramE" }, [
                  _vm._v("as a result of")
                ]),
                _vm._v(
                  " a request\nfor account deletion. We will notify you once the deletion has been completed.\nNOTE: You must be logged into your account to perform this action."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [_c("b", [_vm._v("Getting a Copy of Your Data")])]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [
                _vm._v(
                  "If\nyou would like to receive a copy of the data we have stored in connection to\nyour account, please send a request using the SEND REQUEST button within the Account Settings page of the site. Please note that data\nrequest will be delivered by email only to the email address registered to the\naccount."
                ),
                _c("span", { staticStyle: { "mso-spacerun": "yes" } }),
                _vm._v(
                  "If you are not a registered\nUser of our site, we store no personally identifiable data about you and\ntherefore cannot provide you with a copy of your data. NOTE: You must be logged\ninto your account to perform this action."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [_vm._v(" ")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "MsoNormal" }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-family": '"Arial",sans-serif',
                  "mso-hansi-theme-font": "minor-latin",
                  "mso-bidi-theme-font": "minor-latin"
                }
              },
              [
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Third Party Websites")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\nViewers may find advertising or other content on our Site that link to the\nsites and services of our partners, suppliers, advertisers, sponsors, licensors\nand other third parties. We do not control the content or links that appear on\nthese sites and are not responsible for the practices employed by websites\nlinked to or from our Site. In addition, these "
                ),
                _c("span", { staticClass: "GramE" }, [_vm._v("sites")]),
                _vm._v(
                  "\nor services, including their content and links, may be constantly changing.\nThese sites and services may have their own privacy policies and customer\nservice policies. Browsing and interaction on any other website, including\nwebsites which have a link to our Site, is subject to that website’s own terms\nand policies."
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Advertising")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\nAds appearing on our site may be delivered by advertising partners, who may set\ncookies. These cookies may allow the advertiser’s server to recognize your\ncomputer, each time they send you an online advertisement, to compile non\npersonal identification information about you or others who use your computer.\nThis information allows advertising networks to, among other things, deliver\ntargeted advertisements that they believe will be of most interest to you. This\nprivacy policy does not cover the use of cookies by any advertiser."
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Changes to this Privacy Policy")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\nSlink, Inc., has the discretion to update this privacy policy at any time. When\nwe do, we will revise the “updated” date at the bottom of the applicable page.\nWe encourage frequent checking of this page for any changes to stay informed\nabout how we are helping to protect information we collect. You acknowledge and\nagree that it is your responsibility to review this privacy policy periodically\nand become aware of any modifications."
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Your Acceptance of these Terms")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\nBy using this Site, you signify your acceptance of this Policy. If you do not\nagree to this policy, do not use our Site. In addition, your continued use of\nthe Site, following the posting of changes to this Policy, will be deemed your\nacceptance of those changes."
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("GDPR Representative in the EU")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v("\nGustavo Medina del Rosario"),
                _c("br"),
                _vm._v("\nThe Singular Factory SL"),
                _c("br"),
                _vm._v("\nAvenida Pintor Felo Monzón, 34 - Bajo"),
                _c("br"),
                _vm._v("\n35019 Las Palmas de Gran Canaria"),
                _c("br"),
                _vm._v("\nIslas Canarias, España"),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Contacting Us")]),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\nIf you have any questions about this Privacy Policy, the practices of this\nsite, or your dealings with this site, please contact us at:"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("span", [
              _c(
                "a",
                {
                  staticStyle: { color: "white" },
                  attrs: { href: "mailto:legal@slink.com" }
                },
                [_c("b", [_vm._v("legal@slink.com")])]
              )
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6da00ad8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6da00ad8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Privacy.vue
// module id = null
// module chunks = 